"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_INT16 = 32768;
exports.MIN_INT16 = -32767;
function unpackInt16(a, b) {
    a = Math.min(Math.max(0, Math.floor(a)), 255);
    b = Math.min(Math.max(0, Math.floor(b)), 255);
    return a * 256 + b - 32767;
}
exports.unpackInt16 = unpackInt16;
function packInt16(f) {
    var arr = new Array(2);
    f = Math.min(Math.max(-32767, Math.round(f)), 32768) + 32767;
    arr[0] = Math.floor(f / 256);
    arr[1] = f - arr[0] * 256;
    return arr;
}
exports.packInt16 = packInt16;
//# sourceMappingURL=vectorInt16.js.map